module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1BtvLRs/tc-custom/cover.jpg?1692013024833?1701948655884",
      "alt": "This image is the cover for the book Holy Spokes"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Holy Spokes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("After Laura Everett's car died on the highway one rainy night, she made the utterly practical decision to start riding her bicycle to work through the streets of Boston. Seven years later, she's never looked back."), _c('br'), _c('br'), _c('i', [_vm._v("Holy Spokes")]), _vm._v(" tells the story of Everett's unlikely conversion to urban cycling. As she pedaled her way into a new way of life, Everett discovered that her year-round bicycle commuting wasn't just benefiting her body, her wallet, and her environment. It was enriching her soul."), _c('br'), _c('br'), _vm._v(" Ride along with Everett through "), _c('i', [_vm._v("Holy Spokes")]), _vm._v(" as she explores the history of cycling, makes friends with a diverse and joyful community of fellow cyclists, gets up close and personal with the city she loves—and begins to develop a deep, robust, and distinctly urban spirituality.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Laura Everett\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0